import React, { useEffect, useState } from 'react';

export function FontSearchInput({ value, onSearch }) {
  const [draft, setDraft] = useState(value || '');

  useEffect(() => {
    setDraft(value || '');
  }, [value]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      onSearch(draft);
    }, 300);

    return () => clearTimeout(timeout);
  }, [draft, onSearch]);

  return (
    <label className="mp-font-picker-search">
      <span className="mp-font-picker-search__icon" aria-hidden="true">⌕</span>
      <input
        value={draft}
        onChange={(event) => setDraft(event.target.value)}
        placeholder="Buscar Fonte..."
        aria-label="Buscar fonte"
      />
    </label>
  );
}

export default FontSearchInput;
